import React from 'react';

export const IconPlus = props => (
  <svg viewBox="0 0 12.5 12.5" {...props}>
    <title>Plus</title>
    <path d="M11.75 5.61H7V.75a.75.75 0 0 0-1.5 0v4.86H.75a.75.75 0 0 0 0 1.5H5.5v4.64a.75.75 0 0 0 1.5 0V7.11h4.75a.75.75 0 0 0 0-1.5z" />
  </svg>
);
